"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryOrganizationRole = exports.arbitraryOrganizationHandle = void 0;
exports.arbitraryOrganization = arbitraryOrganization;
exports.arbitraryOrganizationMember = arbitraryOrganizationMember;
exports.arbitraryOrganizationPrivateMetadata = arbitraryOrganizationPrivateMetadata;
exports.arbitraryOrganizationMemberWithOrganization = arbitraryOrganizationMemberWithOrganization;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const lodash_1 = require("lodash");
const handle_1 = require("../../src/handle");
const plan_1 = require("../../src/plan");
const identifier_1 = require("./identifier");
const payment_1 = require("./payment");
const social_1 = require("./social");
const user_1 = require("./user");
/**
 * Handles must be alphanumeric strings with dashes
 */
exports.arbitraryOrganizationHandle = fast_check_1.default
    .hexaString({
    minLength: 3,
})
    .filter((s) => handle_1.OrganizationHandle.safeParse(s).success) // Because must start with a non-numeric character
    .map((s) => handle_1.OrganizationPublicHandle.parse(s));
exports.arbitraryOrganizationRole = fast_check_1.default.constantFrom("member", "owner");
function arbitraryOrganization(constraints = {}) {
    const uid = constraints.uid ? fast_check_1.default.constant(constraints.uid) : identifier_1.arbitraryOrganizationUid;
    const handle = constraints.handle ? fast_check_1.default.constant(constraints.handle) : exports.arbitraryOrganizationHandle;
    const enterpriseUid = "enterpriseUid" in constraints
        ? !constraints.enterpriseUid || typeof constraints.enterpriseUid === "string"
            ? fast_check_1.default.constant(constraints.enterpriseUid)
            : fast_check_1.default.oneof(constraints.enterpriseUid)
        : fast_check_1.default.constant(undefined); // Test using 'in' so it can be forced to undefined
    const planCategory = constraints.planCategory
        ? fast_check_1.default.constant(constraints.planCategory)
        : payment_1.arbitraryOrganizationPaymentPlanCategory;
    const visibility = constraints.visibility
        ? fast_check_1.default.constant(constraints.visibility)
        : fast_check_1.default.constantFrom("public", "unlisted");
    return fast_check_1.default
        .tuple(uid, handle, enterpriseUid, visibility, planCategory, fast_check_1.default.string(), fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }), fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }), (0, social_1.arbitraryDocumentCount)(), (0, social_1.arbitraryPartsCount)(), (0, social_1.arbitraryFollowerCount)(), (0, social_1.arbitraryFollowingCount)())
        .map(([uid, handle, enterpriseUid, visibility, planCategory, displayName, firstDate, secondDate, documentsCount, partsCount, followerCount, followingCount, ,]) => {
        // Created at always happens before updated at (and both are already bounded to always be in the past)
        let createdAt = Math.min(firstDate.valueOf(), secondDate.valueOf());
        let updatedAt = Math.max(firstDate.valueOf(), secondDate.valueOf());
        if (constraints.createdNow) {
            createdAt = updatedAt = Date.now();
        }
        return {
            uid,
            handle,
            enterpriseUid,
            visibility,
            displayName,
            createdAt,
            updatedAt,
            documentsCount,
            partsCount,
            follower_count: followerCount,
            following_count: followingCount,
            isTest: true,
            activeProductUid: plan_1.PaymentPlanUids[planCategory],
        };
    });
}
function arbitraryOrganizationMember(constraints = {}) {
    return arbitraryOrganizationMemberWithOrganization(constraints).map((o) => (0, lodash_1.omit)(o, "organization"));
}
function arbitraryOrganizationPrivateMetadata() {
    return fast_check_1.default.record({
        uid: identifier_1.arbitraryOrganizationUid,
        payment: fast_check_1.default.record({
            customerUid: fast_check_1.default.hexaString({ minLength: 16, maxLength: 16 }).map((s) => `cus_test${s}`),
        }),
        editors: fast_check_1.default.record({
            count: fast_check_1.default.integer({ min: 1, max: 100 }),
            needsCountAfter: fast_check_1.default.option(fast_check_1.default.date().map((d) => d.valueOf()), { nil: undefined }),
        }),
    });
}
function arbitraryOrganizationMemberWithOrganization(constraints = {}) {
    const user = constraints.user ? fast_check_1.default.constant(constraints.user) : (0, user_1.arbitraryUser)();
    const organization = constraints.organization ? fast_check_1.default.constant(constraints.organization) : arbitraryOrganization();
    const role = constraints.role ? fast_check_1.default.constant(constraints.role) : exports.arbitraryOrganizationRole;
    return fast_check_1.default
        .tuple(user, organization, role, fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }), fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }))
        .map(([user, organization, role, firstDate, secondDate]) => {
        // Created at always happens before updated at (and both are already bounded to always be in the past)
        let createdAt = Math.min(firstDate.valueOf(), secondDate.valueOf());
        let updatedAt = Math.max(firstDate.valueOf(), secondDate.valueOf());
        if (constraints.createdNow) {
            createdAt = updatedAt = Date.now();
        }
        return {
            userUid: user.uid,
            userHandle: user.handle,
            organizationUid: organization.uid,
            organization,
            enterpriseUid: organization.enterpriseUid,
            visibility: organization.visibility,
            role,
            createdAt,
            updatedAt,
        };
    });
}
//# sourceMappingURL=organization.js.map